import React from "react"
import { useTranslation } from "react-i18next"

const EmptyState = ({ title, subtitle = "" }) => {
  const { t } = useTranslation()
  return (
    <div className="text-center py-5">
      <i className="bx bx-data font-size-48 text-muted d-block mb-3"></i>
      <h5 className="text-muted">{title || t("No data found")}</h5>
      {subtitle && <p className="text-muted mb-0">{subtitle}</p>}
    </div>
  )
}

export default EmptyState
